import { all, fork } from "redux-saga/effects"
import LayoutSaga from "./layout/saga";
import authSaga from "./auth/saga";
import blockChainSaga from "./blockchain/saga";
import nftSaga  from "./paymentnft/saga";

export default function* rootSaga() {
  yield all([
    fork(LayoutSaga),
    fork(authSaga),
    fork(blockChainSaga),
    fork(nftSaga)
  ])
}
